import { ArrowLeftIcon, Cog6ToothIcon, DocumentCheckIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import { AccountType, DocumentType } from "../../models";
import { useState, useEffect } from "react";
import { useAuth } from "../../store";
import { useContextState } from "../../context/Context";

const Information = () => {
  const { accountCTX } = useContextState();
  const { accountType, profile, setProfile } = accountCTX

  const { logout } = useAuth();

  const navigate = useNavigate();

  useEffect(() => {
    if (!profile){navigate("/")}
    // load();
  }, []);

  const goBack = () => {
    navigate("/dashboard/profile");
  };

  return (
    <div className="w-full h-full  bg-white p-8">
      <div className="h-16 w-full  bg-white p-1 flex justify-between items-center">
        <button onClick={goBack} className="">
          <ArrowLeftIcon className="w-8" />
        </button>
        <h3>Infos du compte</h3>
        <button className="rounded-2xl w-12 h-12 flex justify-center items-center border aspect-square">
          <Cog6ToothIcon className="w-8" />
        </button>
      </div>

      {/*  */}
      <div className="w-full mb-8">
        {/*  */}
        <div className="w-full space-y-4">
          <div className="h-32 flex justify-center items-center mb-8">
            <img
              src={profile?.avatar}
              className="h-24 w-24 rounded-full"
              alt=""
            />
          </div>
          <div className="w-full border-b flex p-1 ">
            <div className="w-1/2">Nom </div>
            <div className="w-1/2 text-primary">: {profile?.name}</div>
          </div>
          <div className="w-full border-b flex p-1 ">
            <div className="w-1/2">Contact </div>
            <div className="w-1/2 text-primary">: {profile?.number}</div>
          </div>
          <div className="w-full border-b flex p-1 ">
            <div className="w-1/2">Pseudo </div>
            <div className="w-1/2 text-primary">: {profile?.username || 'Néant'}</div>
          </div>
          <div className="w-full border-b flex p-1 ">
            <div className="w-1/2">Statut </div>
            <div className="w-1/2 text-primary">: Actif</div>
          </div>
        </div>

        {/* documents */}
        {/* <div className="w-full space-y-4 mt-16">
          <h3 className="text-center text-primary font-bold text-lg">
            Mes documents
          </h3>
          {profile?.required_document.map((item: DocumentType) => (
            <div className="w-full border rounded-lg p-2 flex justify-between">
              <div className="flex gap-2 items-center" >
                <DocumentCheckIcon className="w-8" />
                <span>{item}</span>
              </div>
              <span className="text-green-500">Validé</span>
            </div>
          ))}
        </div> */}
      </div>
    </div>
  );
};
export default Information;
